import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

export interface CanComponentDeactivate {
  isFormDirty: () => boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {

	private cancelClic =  false;

  canDeactivate(component: CanComponentDeactivate): boolean {
    if (component && typeof component.isFormDirty === 'function' && component.isFormDirty()) {
			if(this.cancelClic)
			{
				this.cancelClic = !this.cancelClic;
				return false;
			}
      const result = confirm('Attention, vous allez changer de page, les informations saisies ne seront pas conservées. Voulez-vous vraiment quitter ?');
      if (!result) {
				this.cancelClic = true;
        return false;
      }
      return true;
    }
    return true;
  }
}

